import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="about-content">
        <h1>About The Otto</h1>
        <p>
          Welcome to <strong>The Otto</strong> – where culinary passion meets timeless ambiance.
          Founded with a mission to deliver gourmet comfort food, our team of chefs craft every dish
          using only the freshest ingredients and boldest flavors.
        </p>
        <p>
          Whether you're craving a stacked signature burger, house-made pasta, or decadent desserts,
          our menu celebrates both tradition and creativity. With a space designed for both intimate
          dinners and lively gatherings, The Otto is your neighborhood go-to for memorable meals.
        </p>
        <p>
          Thank you for being part of our story. We’re thrilled to serve you!
        </p>
      </div>
    </div>
  );
}

export default About;
